import { render, staticRenderFns } from "./DiscussionReply.vue?vue&type=template&id=9d921d7c&scoped=true&"
import script from "./DiscussionReply.vue?vue&type=script&lang=js&"
export * from "./DiscussionReply.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionReply.vue?vue&type=style&index=0&id=9d921d7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d921d7c",
  null
  
)

export default component.exports